import { render, staticRenderFns } from "./Buywh10.vue?vue&type=template&id=dc8c9f42&scoped=true&"
import script from "./Buywh10.vue?vue&type=script&lang=js&"
export * from "./Buywh10.vue?vue&type=script&lang=js&"
import style0 from "./Buywh10.vue?vue&type=style&index=0&id=dc8c9f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8c9f42",
  null
  
)

export default component.exports